import { useState } from 'react';
import { AppPage } from 'components/app-page/AppPage';
import CheckImport from '@pages/upload-pages/import-telesales/CheckImport';
import UploadFile from '@pages/upload-pages/import-telesales/UploadFile';



export const ImportTelesales = () => {

	const [ allowImport, setAllowImport ] = useState(false);

	return (
		<AppPage
			className='upload-page'
			pageLabel='Nahrávání souborů - Telesales'
		>
			<div className='upload-content'>	
				
				{allowImport === true &&
					<UploadFile uploadReset={() => setAllowImport(false)} />}

				{allowImport === false &&
					<CheckImport allowUpload={() => setAllowImport(true)}/>}

			</div>

		</AppPage>
	)
}

export default ImportTelesales;